<p>
  booking-progress-dialog works!
</p>
